import React from 'react';
import {
  Card,
  type CardProps,
} from 'src/modules/shared/components/atoms/cards';
import { CardBody } from 'src/modules/shared/components/atoms/cards/card-body';
import { CardHeader } from 'src/modules/shared/components/atoms/cards/card-header';
import { Text } from 'src/modules/shared/components/atoms/text';
import type { ReactNode } from 'react';

export interface IntegrationCardProps {
  title: string;
  subtitle: ReactNode;
  badges?: ReactNode;
  meta?: ReactNode;
  rightAction?: ReactNode;
  icon?: ReactNode;
  children?: ReactNode;
  cardProps?: Omit<CardProps, 'children'>;
}

export const IntegrationCard: React.FC<IntegrationCardProps> = ({
  title,
  subtitle,
  badges,
  meta,
  rightAction,
  icon,
  children,
  cardProps,
}) => {
  const subtitleNode =
    typeof subtitle === 'string' ? (
      <Text size="paragraph" color="secondary">
        {subtitle}
      </Text>
    ) : (
      <div className="text-sm text-secondary-600">{subtitle}</div>
    );

  return (
    <Card {...cardProps}>
      <CardHeader className="flex flex-col sm:flex-row sm:items-start items-stretch justify-between gap-3">
        <div className="flex items-start gap-3 min-w-0">
          {icon ? <div className="shrink-0">{icon}</div> : null}
          <div className="flex flex-col gap-2 min-w-0">
            <div className="flex flex-col gap-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap min-w-0">
                <Text size="h6" weight="medium">
                  {title}
                </Text>
                {badges ? <div className="min-w-0">{badges}</div> : null}
              </div>
              {subtitleNode}
              {meta ? <div className="pt-1">{meta}</div> : null}
            </div>
          </div>
        </div>

        {rightAction ? (
          <div className="shrink-0 w-full sm:w-auto flex sm:block justify-end">
            {rightAction}
          </div>
        ) : null}
      </CardHeader>

      <CardBody>{children}</CardBody>
    </Card>
  );
};
